module.exports = __webpack_public_path__ + "Roboto-Thin.954bbdeb86483e4ffea0.woff2";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Thin.woff2
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Thin.woff2
// module chunks = styles